import _ from 'lodash';

import reportFromJs from 'models/reports/report_from_js';

export default {
  fromDto(dto, type) {
    return reportFromJs({ timezone: dto.timezone, data: _.omit(dto, 'timezone'), type });
  },
};
